import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import sistemaListStore, {
  sistemaListShowModal,
} from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

import ShowConfirmacao from '~/utils/ShowConfirmacao';
import { schema, emptyDefaultValues, buildFuncionarioPayload } from '../formSchema';
import * as service from '../service';
import FuncionarioFormFields from '../FuncionarioFormFields';

function CreateContent({ refetch }) {
  const { dispatch } = React.useContext(sistemaListStore);

  const {
    register,
    control,
    watch,
    formState: { errors },
    handleSubmit: handleFormSubmit,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: emptyDefaultValues,
  });

  async function handleSubmit(data) {
    return ShowConfirmacao(
      async () => {
        const response = await service.create(buildFuncionarioPayload(data));

        if (response?.data) {
          refetch && (await refetch());
          dispatch(sistemaListShowModal(false));
        }

        return response;
      },
      {
        message: 'Tem certeza que deseja cadastrar este funcionário?',
        successModal: 'Funcionário cadastrado com sucesso!',
        errorModal: {
          defaultMessage: 'Ocorreu um erro ao cadastrar o funcionário. Por favor, tente novamente.',
        },
      },
    );
  }

  return (
    <SLForm onSubmit={handleFormSubmit(handleSubmit)} defaultStyle>
      <FuncionarioFormFields register={register} control={control} errors={errors} watch={watch} />
    </SLForm>
  );
}

export default CreateContent;
